/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Block} from 'baseui/block'
import {Button, KIND} from 'baseui/button'
import isEmpty from 'lodash/isEmpty'
import React from 'react'
import {useLocation} from 'react-router-dom'
import {Link} from 'react-router-dom'
import {navigation} from '../../utils/config'

const renderMenu = menu =>
  menu.map(item => {
    const location = useLocation()
    const url = String(item?.url ?? '')

    if (isEmpty(url)) return null

    return (
      <Button
        kind={KIND.tertiary}
        $as={Link}
        to={url.includes('#') ? '#' : url}
        disabled={url.includes('#') || url === location.pathname}
        key={url}
        overrides={{
          BaseButton: {
            style: ({$theme}) => ({
              color:
                String(url).includes('#') || url === location.pathname
                  ? $theme.colors.primary500
                  : $theme.colors.primary50,
              backgroundColor: 'transparent',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'stretch',
              flex: 1,
              fontWeight: 700,
              paddingBottom: $theme.sizing.scale800,
              paddingTop: $theme.sizing.scale800,
              ':hover': {
                color: $theme.colors.primary500,
                backgroundColor: 'transparent',
              },
            }),
          },
        }}
      >
        <FontAwesomeIcon icon={item.icon} />
      </Button>
    )
  })

const FooterMobileMenu = () => {
  return (
    <Block
      overrides={{
        Block: {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
      }}
    >
      {renderMenu(navigation.small.footer)}
    </Block>
  )
}

export default FooterMobileMenu
